import { CourseDaysLesson, CourseVolume } from '.';
export class CourseDay {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "day", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSkipped", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completedCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "courseDaysLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volume", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.day = data.day;
        this.totalDuration = data.totalDuration;
        this.isCompleted = data.isCompleted;
        this.isSkipped = data.isSkipped;
        this.completedCount = data.completedCount;
        this.courseDaysLessons = data.courseDaysLessons
            ? data.courseDaysLessons.map((o) => new CourseDaysLesson(o, config))
            : [];
        this.volume = data.courseVolume ? new CourseVolume(data.courseVolume, config) : null;
    }
    get currentLesson() {
        var _a;
        return (_a = this.courseDaysLessons.find((lesson) => !lesson.isCompleted)) !== null && _a !== void 0 ? _a : this.courseDaysLessons[0];
    }
    get isFirstCompleted() {
        return this.completedCount >= 1;
    }
}
